

































import {Mixins, Component, Prop} from 'vue-property-decorator';
import MallInfo from '@/components/term/mixins/MallInfo';
import Groups from '@/components/term/mixins/Groups';

@Component
export default class ContentBottom extends Mixins(MallInfo, Groups) {
  @Prop({required: true}) private currentGroup!: string;
}
